export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        slotProps: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    // language=HTML
    template: `
      <portal-target :name="name" :slot-props="slotProps" slim></portal-target>
  `,
};
